import {StoichiometryCustomEvalOptions} from 'notebook/integrations/chemistry/StoichiometryStructuredTableAdapter';
import {ColumnDefinition} from 'notebook/structured-tables/columns/ColumnDefinitions';
import {Warning} from 'notebook/tables/excess/Util';
import {BaseTypedValueType, CustomEvalResult, TypedValue} from 'notebook/tables/TableConstants';
import {ResolveQueryFn, ResolveTypedValueToTypeFn} from 'notebook/tables/typed-values/TypedValueResolution';

const UNRECOGNIZED_MOLECULE_MESSAGE =
  'Unrecognized molecule — create this molecule in the registry, then update this row.';

export function unrecognizedMoleculeCustomEval(
  typedValue: TypedValue,
  columnDefinition: ColumnDefinition | null,
  cellDependencies: Array<TypedValue | null>,
  customEvalOptions: StoichiometryCustomEvalOptions,
  _resolveFromResolutionQuery: ResolveQueryFn,
  _resolveTypedValueToType: ResolveTypedValueToTypeFn
): CustomEvalResult {
  const {rowMetadata} = customEvalOptions;

  if (
    rowMetadata?.canonicalSmiles != null &&
    typedValue?.type === BaseTypedValueType.STRING &&
    typedValue.rawValue != null &&
    typedValue.rawValue.length > 0
  ) {
    return {
      val: typedValue,
      error: new Warning(UNRECOGNIZED_MOLECULE_MESSAGE),
      locked: false,
    };
  }

  return {val: typedValue, error: null, locked: false};
}
